import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faCaretLeft,
  faCaretRight,
  faCircleLeft,
  faCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { ShoppingCart, PawPrint, WandSparkles } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";

const QrTagSlider = ({ t, handleAddToCart }) => {
  const qrTagSwiperRef = useRef(null);

  const handlePrev = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <div className="qr-tag-list-container">
      <div className="qr-tag-list-container-title">
        <p> {t("choose qr tag for your pet")} </p>
      </div>
      <div className="qr-tag-list-inside-container">
        <a className="prev" onClick={() => handlePrev(qrTagSwiperRef)}>
          <FontAwesomeIcon icon={faCaretLeft} size="sm" />
        </a>
        <a className="next" onClick={() => handleNext(qrTagSwiperRef)}>
          <FontAwesomeIcon icon={faCaretRight} size="sm" />
        </a>
        <Swiper
          ref={qrTagSwiperRef}
          wrapperClass="cards-swiper-container"
          spaceBetween={15}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
            },
            768: {
              slidesPerView: 3,
            },
            1023: {
              slidesPerView: 3.5,
            },
            1024: {
              slidesPerView: 3.5,
            },
            1281: {
              slidesPerView: 5,
            },
            1601: {
              slidesPerView: 5,
            },
          }}
        >
          {/* Orange */}
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-1">
              <div className="qr-tag-card-imgbox">
                <img className="front-img" src="/img/1-1.webp" alt="" />
                <img className="back-img" src="/img/1.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("orange")} </p>
              <p className="qr-tag-price">
                <span className="base-price">55 {t("gel")}</span>
                <span className="sale-price">29 {t("gel")}</span>
              </p>
              <button
                className="order-now-button"
                onClick={() => handleAddToCart("orange")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>

          {/* Cream */}
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-2">
              <div className="qr-tag-card-imgbox">
                <span className="best-seller-badge">
                  {/* <FontAwesomeIcon icon={faFireFlameCurved} /> */}
                  {t("most popular")}
                </span>
                <img className="front-img" src="/img/1-2.webp" alt="" />
                <img className="back-img" src="/img/2.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("cream")} </p>
              <p className="qr-tag-price">
                <span className="base-price">55 {t("gel")}</span>
                <span className="sale-price">29 {t("gel")}</span>
              </p>
              <button
                className="order-now-button"
                onClick={() => handleAddToCart("cream")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>

          {/* Black */}
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-3">
              <div className="qr-tag-card-imgbox">
                <img className="front-img" src="/img/1-3.webp" alt="" />
                <img className="back-img" src="/img/3.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("black")} </p>
              <p className="qr-tag-price">
                <span className="base-price">55 {t("gel")}</span>
                <span className="sale-price">29 {t("gel")}</span>
              </p>
              <button
                className="order-now-button"
                onClick={() => handleAddToCart("black")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>

          {/* Pink */}
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-4">
              <div className="qr-tag-card-imgbox">
                <img className="front-img" src="/img/1-4.webp" alt="" />
                <img className="back-img" src="/img/4.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("pink")} </p>
              <p className="qr-tag-price">
                <span className="base-price">55 {t("gel")}</span>
                <span className="sale-price">29 {t("gel")}</span>
              </p>
              <button
                className="order-now-button"
                onClick={() => handleAddToCart("pink")}
              >
                {t("add to cart")} <ShoppingCart />
                {/* <FontAwesomeIcon icon={faCartShopping} size="sm" /> */}
              </button>
            </div>
          </SwiperSlide>

          {/* By own design */}
          <SwiperSlide>
            <div className="qr-tag-card">
              <div className="qr-tag-card-imgbox">
                <img className="front-img" src="/img/1-5.webp" alt="" />
                <img className="back-img" src="/img/5.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("by own design")} </p>
              <p className="qr-tag-price">
                <span className="base-price">55 {t("gel")}</span>
                <span className="sale-price">29 {t("gel")}</span>
              </p>
              <Link to="/order/qrcollar" className="order-now-button">
                {t("create")}
                <WandSparkles />
              </Link>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default QrTagSlider;
